import {toast} from "react-toastify";

export const uploadFile = async (
    file: File,
    type: string
): Promise<string> => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/upload/${type}`, {
        method: "POST",
        body: formData,
    });

    if (!response.ok) {

        toast.error('File upload failed')
        // throw new Error("File upload failed");
    }

    const data = await response.json();

    return data.url; // ✅ S3 URL
};
